export * from "./privacy-policy-section-content"